"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEasternTimeLuxon = exports.getEasternTime = void 0;
const timeZones_1 = require("../../constants/timeZones");
const luxon_1 = require("luxon");
function getEasternTime(format) {
    const hasDateTimeOverride = areWeTesting() && process.env.DATETIME_OVERRIDE;
    const dateTime = hasDateTimeOverride
        ? luxon_1.DateTime.fromISO(process.env.DATETIME_OVERRIDE)
        : luxon_1.DateTime.now().setZone(timeZones_1.TIME_ZONE.EASTERN);
    switch (format) {
        case 'ISO_DATE_BASIC':
            return dateTime.toISODate({ format: 'basic' });
        case 'ISO_DATE_TIME':
            return dateTime.toISO();
        default:
            return dateTime.toISODate();
    }
}
exports.getEasternTime = getEasternTime;
function getEasternTimeLuxon() {
    const hasDateTimeOverride = areWeTesting() && process.env.DATETIME_OVERRIDE;
    return hasDateTimeOverride
        ? luxon_1.DateTime.fromISO(process.env.DATETIME_OVERRIDE)
        : luxon_1.DateTime.now().setZone(timeZones_1.TIME_ZONE.EASTERN);
}
exports.getEasternTimeLuxon = getEasternTimeLuxon;
function areWeTesting() {
    return !!(process.env.TEST_MODE === 'true') || !(process.env.JEST_WORKER_ID === undefined);
}
//# sourceMappingURL=index.js.map